import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class VssFile {
  id: number;
  fileName: string;
  filePath: string;
}

@Injectable({
  providedIn: 'root'
})
export class VssFilesUploadService {

  constructor(private _http: HttpClient) { }

  public getVssOrganizationFiles(orgId: string, type: string): Observable<VssFile[]> {
    let path = 'vss/generalFile/get';
    switch (type) {
      case 'trainingSession':
        path = 'vss/trainingSessionFile/get';
        break;
      case 'events':
        path = 'vss/event/docs/get';
        break;
    }
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    // VssOrganization
    return this._http.get<VssFile[]>(environment.serverUrl + path, {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitOrganizationImage
   */
  public uploadFile(file: File, fileName: string, orgId: number, type: string) {
    let path = 'vss/generalFile/upload';
    switch (type) {
      case 'trainingSession':
        path = 'vss/trainingSessionFile/upload';
        break;
      case 'events':
        path = 'vss/event/uploadDoc';
        break;
    }
    const formData = new FormData();
    formData.append('id', orgId.toString());
    // formData.append('imageName', fileName);
    formData.append('image', file, file.name);
    return this._http.post<any>(
      environment.serverUrl + path,
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteFile(id: number, type: string): Observable<any> {
    let path = 'vss/generalFile/delete';
    switch (type) {
      case 'trainingSession':
        path = 'vss/trainingSessionFile/delete';
        break;
      case 'events':
        path = 'vss/event/deleteFile';
        break;
    }
    return this._http.delete<void>(
      environment.serverUrl + path,
      { params: { id: id.toString() } }
    ).pipe(
      map(result => {
        return result;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
